export default __webpack_public_path__ + "572f47b19b9aca7d264b5ea7acf0fd5d.woff2";